import { useEffect, useState } from 'react';
import { checkAvailability } from './api';
const DEBOUNCE_MS = 300;
/**
 * The technician conflict for `params`, or null. Pass null params to skip the check.
 * Never blocks saving, and a response for superseded params is dropped.
 */
export function useAvailabilityWarning(url, params) {
    const [conflict, setConflict] = useState(null);
    const key = params ? JSON.stringify(params) : null;
    useEffect(() => {
        setConflict(null);
        if (!key)
            return undefined;
        const request = JSON.parse(key);
        const controller = new AbortController();
        const timer = setTimeout(() => {
            checkAvailability(url, request, controller.signal)
                .then((result) => {
                if (!controller.signal.aborted)
                    setConflict(result);
            })
                // Advisory only: a failed check must never block or noise up the form.
                .catch(() => undefined);
        }, DEBOUNCE_MS);
        return () => {
            clearTimeout(timer);
            controller.abort();
        };
    }, [url, key]);
    return conflict;
}
